<script lang="ts">
    import {onMount} from "svelte";


    onMount(() => {
    });


</script>

<div class="home-page standard-page">
    Lexica のホームです。ここでは特にできることはありません。特別なURLから飛んできてください。


</div>
<style lang="scss">
    .home-page {
      margin-top: 60px;

    }
</style>